import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { apihubPost } from "../../api/apihub";

const FIELDS = [
  { name: "currentPassword", label: "Current Password" },
  { name: "newPassword", label: "New Password" },
  { name: "confirmPassword", label: "Confirm New Password" },
];

const ChangePassword = () => {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [show, setShow] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const showKey = (name) => {
    if (name === "confirmPassword") return "confirm";
    if (name === "newPassword") return "new";
    return "current";
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "", server: "" }));
    setSuccess("");
  };

  const validate = () => {
    const next = {};
    if (!form.currentPassword) next.currentPassword = "Current password is required";
    if (!form.newPassword) next.newPassword = "New password is required";
    else if (form.newPassword.length < 8) {
      next.newPassword = "Use at least 8 characters";
    }
    if (!form.confirmPassword) {
      next.confirmPassword = "Please confirm your new password";
    } else if (form.confirmPassword !== form.newPassword) {
      next.confirmPassword = "Passwords do not match";
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    setSuccess("");
    try {
      await apihubPost("/user/changepassword", {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
        confirmNewPassword: form.confirmPassword,
      });
      setSuccess("Password changed successfully.");
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        server: err.message || "Failed to change password",
      }));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="biz-panel-page biz-changepassword-page">
      <div className="biz-panel-header">
        <h1>
          <FaLock />
          Change Password
        </h1>
      </div>

      <div className="biz-changepassword-layout">
        <form className="biz-changepassword-card" onSubmit={onSubmit}>
          {success && <p className="biz-changepassword-success">{success}</p>}

          {FIELDS.map(({ name, label }) => {
            const key = showKey(name);
            return (
              <label key={name} className="biz-changepassword-field">
                <span>{label}</span>
                <div className="biz-changepassword-input-wrap">
                  <input
                    type={show[key] ? "text" : "password"}
                    name={name}
                    value={form[name]}
                    onChange={onChange}
                    autoComplete={
                      name === "currentPassword" ? "current-password" : "new-password"
                    }
                  />
                  <button
                    type="button"
                    className="biz-changepassword-eye"
                    onClick={() =>
                      setShow((prev) => ({ ...prev, [key]: !prev[key] }))
                    }
                    aria-label={show[key] ? "Hide password" : "Show password"}
                  >
                    {show[key] ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {errors[name] && (
                  <span className="biz-changepassword-error">{errors[name]}</span>
                )}
              </label>
            );
          })}

          {errors.server && (
            <p className="biz-changepassword-error biz-changepassword-server">
              {errors.server}
            </p>
          )}

          <button
            type="submit"
            className="biz-btn-primary biz-changepassword-submit"
            disabled={submitting}
          >
            {submitting ? "Updating…" : "Change Password"}
          </button>
        </form>

        <aside className="biz-changepassword-tips">
          <h2>Password Tips</h2>
          <ul>
            <li>
              Use at least <strong>8 characters</strong>.
            </li>
            <li>
              Mix <strong>uppercase</strong>, <strong>lowercase</strong>,{" "}
              <strong>numbers</strong>, and <strong>special characters</strong>.
            </li>
            <li>Avoid personal info or easy words like “password123”.</li>
            <li>Never reuse passwords from other accounts.</li>
            <li>
              Consider a <strong>password manager</strong> for secure storage.
            </li>
          </ul>
        </aside>
      </div>
    </div>
  );
};

export default ChangePassword;
